const BASE_URL_IMAGE = '/images/home/behind-the-magic';

export const DATA = [
  {
    urlImage: `${BASE_URL_IMAGE}/erin.png`,
    title: 'Erin Burchik',
    description: 'Founder of Keepsake Tales'
  },
  {
    urlImage: `${BASE_URL_IMAGE}/mike.png`,
    title: 'Mike Vaggalis',
    description: 'Founder of Keepsake Tales'
  },
  {
    urlImage: `${BASE_URL_IMAGE}/shawna.png`,
    title: 'Shawna Lemon',
    description: 'Legal Lead'
  },
  {
    urlImage: `${BASE_URL_IMAGE}/christina.png`,
    title: 'Christina Dill',
    description: 'Design Lead'
  },
  {
    urlImage: `${BASE_URL_IMAGE}/paulo.png`,
    title: 'Paulo Rieck',
    description: 'Tech Lead'
  },
  {
    urlImage: `${BASE_URL_IMAGE}/john.png`,
    title: 'John Petitte',
    description: 'Tech Lead'
  }
];
